import {
  getUserDetails,
  postUserLogin,
  postUserLogout,
  rolesUser
} from '@/api/Erp'

export default {
  async postUserLogin(userInfo) {
   
    return await postUserLogin.post(
      userInfo
    )
  },
  async getUserDetails(token) {
    try {
      const response = await getUserDetails.get({
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  },
  async postUserLogout(token) {
    try {
      const response = await postUserLogout.post(
        {},
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      )
      return response
    } catch (error) {
      return error.response
    }
  },
  async getRolesUser(token) {
    try {
      const response = await rolesUser.get({
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/users/resources.js